import React from 'react';
import {FormControl, FormLabel, HStack, IconButton, Input} from '@tempo/core';
import {PenIcon} from '@tempo/icons';
import {MODAL_STATE} from '@deezer/next/features/Account/type';
import {useTranslation} from 'next-i18next';
import Tooltip from '@components/Tooltip';

type UserPasswordProps = {
	onModalOpen: (state: MODAL_STATE) => void;
	isDisabled?: boolean;
	canUpdate?: boolean;
};

const UserPassword = ({
	onModalOpen,
	isDisabled,
	canUpdate,
}: UserPasswordProps) => {
	const {t} = useTranslation('d4c');

	const handleOpen = () => onModalOpen(MODAL_STATE.EDIT_PASSWORD);
	return (
		<FormControl>
			<FormLabel>Password</FormLabel>
			<HStack>
				<Input
					name="password"
					placeholder="*********"
					type="password"
					disabled={isDisabled}
				/>
				{!canUpdate ? (
					<Tooltip
						label={t('oktaautherrormessage_text_accountcantbeupdated_d4c-web')}
					>
						<IconButton
							variant="outline"
							aria-label={'edit password icon'}
							icon={<PenIcon />}
							disabled={!canUpdate}
						/>
					</Tooltip>
				) : (
					<IconButton
						variant="outline"
						aria-label={'edit password icon'}
						icon={<PenIcon />}
						onClick={handleOpen}
					/>
				)}
			</HStack>
		</FormControl>
	);
};

export default UserPassword;
